<template>
  <modal v-on="$listeners">
    <template v-slot:header>#{{ tag.name }}</template>

    <div v-if="loading" class="fullscreen-centered">Loading...</div>
    <div v-else-if="noResults" class="fullscreen-centered">No results</div>
    <div v-else>
      <ul class="list-reset">
        <Preview v-for="(note, index) in notes" :key="index" :note="note" :hide-tags="true"/>
      </ul>
      <div v-if="notes.length" class="bottom-actions">
        <div @click="loadMore" class="btn btn-outline btn-rounded caps mx-auto" :class="{ disabled: !showLoadMore }">
          <pulse-loader v-if="loadMoreBusy" :loading="true" :color="'#000000'" :size="'6px'"></pulse-loader>
          <div v-else>Load more</div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios'
  import Preview from '@/components/Preview'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    name: 'ViewTags',
    props: {
      tag: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loading: true,
        notes: [],
        showLoadMore: false,
        loadMoreBusy: false
      }
    },
    computed: {
      noResults () {
        return !this.notes.length
      }
    },
    methods: {
      getResults () {
        /* TODO: filter by linked project (ACF field) */
        this.loading = true
        const query = `?_embed&${this.tag.tagtype}=${this.tag.id}`
        axios.get(`${process.env.VUE_APP_API_ROOT}field_note${query}`).then(({ data }) => {
          this.loading = false
          this.notes = data
        })
      },
      loadMore () {}
    },
    watch: {
      tag () {
        this.getResults()
      }
    },
    mounted () {
      this.getResults()
    },
    components: { Preview, PulseLoader }
  }
</script>
